import CountryPageTemplate from "../../components/country/CountryPageTemplate";
import { countryPages } from "../../data/countries";

function UaePage() {
  return <CountryPageTemplate country={countryPages.uae} />;
}

export default UaePage;
